import React from "react";
import { Link } from "react-router-dom";
import RoomCard from "./RoomCard";

const allRooms = [
  {
    image: "/assets/images/rooms/peak/1.webp?v=20260924",
    title: "The Peak",
    link: "/peakroom",
    beds: "2 beds",
    baths: "2 baths",
    guests: "4 guests",
  },
  {
    image: "/assets/images/rooms/peakfamily/1.webp?v=20260924",
    title: "The Peak Family",
    link: "/peakfamily",
    beds: "2 beds",
    baths: "1 bath",
    guests: "4 guests",
  },
  {
    image: "/assets/images/rooms/foresttriple/2.webp?v=20260924",
    title: "Forest View Triple Room",
    link: "/foresttriple",
    beds: "2 beds",
    baths: "1 bath",
    guests: "3 guests",
  },
  {
    image: "/assets/images/rooms/forestdouble/1.webp?v=20260924",
    title: "The Forest Double Room",
    link: "/forestdouble",
    beds: "2 beds",
    baths: "1 bath",
    guests: "2 guests",
  },
  {
    image: "/assets/images/rooms/foresttwin/2.webp?v=20260924",
    title: "The Forest Twin Room",
    link: "/foresttwin",
    beds: "2 beds",
    baths: "1 bath",
    guests: "2 guests",
  },
];

function Room() {
  return (
    <section className="villa-one our-rooms-section">
      <div className="container">
        <div className="sec-title text-center">
          <h3 className="sec-title__title">Our Rooms</h3>
        </div>
        <div className="room-grid">
          {allRooms.map((room) => (
            <div className="item" key={room.link}>
              <RoomCard {...room} />
            </div>
          ))}
        </div>
        <div className="text-center" style={{ marginTop: 24 }}>
          <Link to="/rooms" className="villoz-btn">
            <i>View All Rooms</i>
            <span>View All Rooms</span>
          </Link>
        </div>
      </div>
    </section>
  );
}

export default Room;
